import axios from 'axios'
import { message } from 'ant-design-vue'

export default {
  namespaced: true,
  state: {
    metadata: []
  },
  mutations: {
    metadata: (state, metadata) => state.metadata = metadata
  },
  actions: {
    ticketMetadata ({ rootState, commit }) {
      return axios.get(`${rootState.jira.endpoint}/rest/api/3/issue/createmeta`, {
        headers: { Authorization: `Bearer ${rootState.jira.token}` }
      })
        .then(({ data }) => commit('metadata', data.projects))
    },
    createTicket ({ rootState }) {
      const data = {
        fields: {
          summary: rootState.issue.title,
          issuetype: { id: rootState.issue.type },
          project: { id: rootState.issue.project }
        }
      }

      return axios.post(`${rootState.jira.endpoint}/rest/api/3/issue`, data, {
        headers: { Authorization: `Bearer ${rootState.jira.token}` }
      })
        .then(({ data }) => {
          message.success(`Created ${data.key}`, 5)
          console.log('createTicket', data)
        })
    }
  }
}
